import React from "react";
import { motion } from "framer-motion";
import { CtaButton } from "./CtaButton";
import { PianoKeys } from "./PianoKeys";
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-135" data-mp="ei1wlphg28zj">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-20 text-center md:pt-24" data-id="element-136" data-mp="9ll9mylze0o1">
        <p className="flex items-center justify-center gap-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-wood" data-id="element-137" data-mp="4mi319qcrmdy">
          <span className="hidden h-px w-10 bg-wood/60 sm:block" aria-hidden="true" data-id="element-138" data-mp="128yxm77pblw0" />
          La méthode complète pour les professeurs de piano
          <span className="hidden h-px w-10 bg-wood/60 sm:block" aria-hidden="true" data-id="element-139" data-mp="sbb5lp1hcshj" />
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 font-display text-5xl uppercase leading-[0.98] text-ink sm:text-7xl lg:text-[96px]" data-id="element-140" data-mp="nc87ypntxojl">
          Organisez toute votre
          <br data-id="element-141" data-mp="3j896tarbk7oh" />
          <span className="mt-3 inline-block bg-walnut px-4 pb-1 text-linen" data-id="element-142" data-mp="3j9kbdcsl9jgn">
            année de cours de piano
          </span>
          <br data-id="element-143" data-mp="3o6u5h5qxajat" />
          avec ce pack
        </motion.h1>

        <p className="mx-auto mt-10 max-w-2xl font-serif text-xl italic leading-relaxed text-stone md:text-2xl" data-id="element-144" data-mp="39b4knaxh4c7o">
          Un guide théorique pour vous et un guide pratique d'exercices pour vos élèves.
          Imprimez, enseignez et regardez-les progresser.
        </p>

        <div className="mt-10 flex flex-col items-center gap-4" data-id="element-145" data-mp="358hmksa7lv21">
          <CtaButton data-id="element-146" data-mp="35aud3tu19dqp" />
          <p className="text-sm text-stone" data-id="element-147" data-mp="2qjv96w457ddg">
            100 % PDF · Reçu immédiatement par e-mail · Garantie 10 jours
          </p>
        </div>
      </div>
      <PianoKeys octaves={5} className="h-14 md:h-20" data-id="element-148" data-mp="2vjg670zr5bnj" />
    </header>;
}